
const PrivacyPopup= () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
    <h1 className="text-3xl font-bold mb-6">개인정보 처리방침</h1>
    
    <section id="purpose" className="mb-8">
      <p>
      주식회사 아이옵스(이하 &quot;회사&quot;)는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법, 통신비밀보호법, 전기통신사업법 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보 처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.
      </p>
    </section>

    <section className="mb-8">
      <span><b>1. 개인정보의 수집/이용목적·항목 및 보유기간</b></span>
      <ol className="pl-5 space-y-2">
        <p>① 회사는 아이옵스스페이스 (이하 ‘서비스’) 회원가입 시 또는 서비스 이용 과정에서 기본적인 서비스 제공을 위해 필수정보와 선택정보로 구분하여 아래와 같은 개인정보를 수집하고 있습니다.</p>
      </ol>
      <span><b>[필수정보]</b></span>
      <ol className="pl-5 space-y-2">
        <p>가. 필수 개인정보의 수집/이용목적·항목</p>
        <table className="border-collapse border border-gray-300 w-full"><caption>개인정보 수집/이용목적 항목 규정</caption>
          <thead>
            <tr>
              <th className="border border-gray-300 px-4 py-2">목적</th>
              <th className="border border-gray-300 px-4 py-2">수집항목</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-4 py-2">본인 인증</td>
              <td className="border border-gray-300 px-4 py-2">이름, 휴대폰번호, 이메일, 회사명, 국가</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">회원 가입</td>
              <td className="border border-gray-300 px-4 py-2">이메일, 비밀번호</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">로그인, ID/PW찾기, 문의하기</td>
              <td className="border border-gray-300 px-4 py-2">이메일, 비밀번호, 접속기록</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">Manage satellite</td>
              <td className="border border-gray-300 px-4 py-2">Manage satellite, Contact Profile, Contact us, Manage Contacts</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">이용권 구매 및 사용내역 조회</td>
              <td className="border border-gray-300 px-4 py-2">이용권 구매/이용/환불 내역</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">결제/취소</td>
              <td className="border border-gray-300 px-4 py-2">이름, 휴대폰번호, 이메일, 카드번호</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">현금영수증 발급</td>
              <td className="border border-gray-300 px-4 py-2">휴대폰번호, 현금영수증카드번호</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">환불 및 환급처리</td>
              <td className="border border-gray-300 px-4 py-2">예금주명, 계좌번호, 계좌은행, 환불 및 환급 내역</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">제휴 문의</td>
              <td className="border border-gray-300 px-4 py-2">이름, 이메일, 회사명, 국가</td>
            </tr>
          </tbody>
        </table>
        <p>나. 필수 개인정보 보유기간</p>
        <p> - 회원 탈퇴 시 분리보관후 목적 달성 시 즉시 파기</p>
        <br/>
        <b>[선택정보]</b>
        <p>가. 선택 개인정보의 수집/이용목적·항목</p>
        <table className="border-collapse border border-gray-300 w-full">
          <thead>
            <tr>
              <th className="border border-gray-300 px-4 py-2">목적</th>
              <th className="border border-gray-300 px-4 py-2">수집항목</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-4 py-2">마케팅 광고 활용 동의</td>
              <td className="border border-gray-300 px-4 py-2">이름, 이메일, 회사명, 국가</td>
            </tr>
          </tbody>
        </table>
        <p> - 마케팅(이벤트) 유형별 수집항목은 다를 수 있으며, 자세한 사항은 이벤트 참여시마다 동의서를 통해 안내됩니다.</p>
        <p>나. 선택 개인정보 보유기간</p>
        <p> - 회원 탈퇴 혹은 마케팅 동의 해제 시 즉시 파기</p>
        <p>② 회사는 회원이 탈퇴하거나 개인정보 이용목적을 달성한 경우 또는 일정기간 서비스를 이용하지 않는 경우 개인정보의 안전한 보호와 이로 인한 피해발생을 방지하기 위해 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 에 정해진 바에 따라 개인정보 분리 보관 및 이용기간에 따라 바로 파기 처리합니다.</p>
        <p>③ 다만, 보유기간과 관련하여 관계법령의 규정에 따라 보존할 의무가 있으면 법령이 정한 기간 동안 고객님의 개인정보를 보유할 수 있으며, 다음에 해당하는 경우를 말합니다.</p>
        <p> - 계약 철회 등에 관한 기록: 5년(전자상거래 등에서의 소비자보호에 관한 법률)</p>
        <p> - 대금 결제 및 재화 등의 공급에 관한 기록: 5년(전자상거래 등에서의 소비자보호에 관한 법률)</p>
        <p> - 이용자의 불만 또는 분쟁 처리에 관한 기록: 3년(전자상거래 등에서의 소비자 보호에 관한 법률)</p>
        <p> - 거래에 관한 장부 및 증빙서류: 5년(국세기본법, 법인세법, 부가가치세법 등)</p>
        <p> - 표시/광고에 관한 기록: 6개월(전자상거래 등에서의 소비자 보호에 관한 법률)</p>
        <p> - 전자금융 거래에 관한 기록: 5년(전자금융거래법)</p>
        <p> - 1:1문의내역의 기록: 3년(전자상거래 등에서의 소비자 보호에 관한 법률)</p>
        <p> - 서비스 방문 기록: 3개월(통신비밀보호법)</p>
        <p>④ 회사는 개인정보의 수집/이용에 법정대리인의 동의가 필요한 만 14세 미만 아동의 개인정보는 원칙적으로 수집하지 않습니다.</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>2. 개인정보 수집방법</b></span>
      <ol className="pl-5 space-y-2">
        <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
        <p> - 서비스 실행 또는 사용시 자동으로 수집하거나 이용자의 자발적 제공을 통해 수집</p>
        <p> - 이메일, 전화, 팩스, 상담 게시판, 유·무선 사이트, 서면양식, 이벤트 응모, 배송요청 등</p>
        <p> - 이동전화 및 유·무선 인터넷 서비스를 사용할 때 생성정보를 수집하는 도구를 통한 방법 등을 통한 수집</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>3. 개인정보의 제 3자 제공</b></span>
      <ol className="pl-5 space-y-2">
        <p>회사는 이용자들의 개인정보를 &quot;개인정보의 수집목적 및 이용목적&quot;에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 주의를 기울여 개인정보를 이용 및 제공할 수 있습니다.</p>
        <p>① 이용자들이 사전에 공개에 동의한 경우</p>
        <p>정보수집 또는 정보제공 이전에 이용자에게 비즈니스 파트너가 누구인지, 그리고 언제까지 어떻게 보호/관리되는지 알려드리고 동의를 구하는 절차를 거치게 되며, 이용자가 동의하지 않는 경우에는 추가적인 정보를 수집하거나 비즈니스 파트너와 공유하지 않습니다.</p>
        <p>② 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</p>
        <p>③ 회사는 통계작성, 학술연구 또는 시장조사를 위하여 필요하다면 이용자가 제공한 개인정보를 식별할 수 없는 형태로 가공하여 제3자에게 제공할 수 있습니다.</p>
        <p>④ 또한 회사는 서비스 제공을 위해 필요한 업무 중 일부를 외부 업체에 위탁하고 있으며, 위탁 시 위탁받은 업체가 ‘개인정보보호법’에 따라 개인정보를 안전하게 취급하도록 필요한 사항을 규정하고 관리/감독하고 있습니다.</p>
        <table className="border-collapse border border-gray-300 w-full">
          <thead>
            <tr>
              <th className="border border-gray-300 px-4 py-2">위탁업체체</th>
              <th className="border border-gray-300 px-4 py-2">위탁목적</th>
              <th className="border border-gray-300 px-4 py-2">개인정보 보유 및 이용기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-4 py-2">AWS(국내)</td>
              <td className="border border-gray-300 px-4 py-2">클라우드 스토리지 서비스</td>
              <td className="border border-gray-300 px-4 py-2">회원탈퇴 또는 위탁계약 종결시 까지</td>
            </tr>
          </tbody>
        </table>
        <p>⑤ 제3자 정보 제공에 관한 사항</p>
        <p>회사는 서비스 제공 및 운영을 위해 아래와 같이 개인정보를 제3자에게 제공합니다.</p>
        <p> - 개인정보 수집 및 이용목적: 수집된 개인정보는 다음 목적을 위해서만 활용되며 이외의 목적으로 활용되지 않습니다. </p>
        <table className="border-collapse border border-gray-300 w-full">
          <thead>
            <tr>
              <th className="border border-gray-300 px-4 py-2">제공받는 자</th>
              <th className="border border-gray-300 px-4 py-2">토스페이먼츠</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-4 py-2">제공 목적</td>
              <td className="border border-gray-300 px-4 py-2">간편결제 서비스 업무 대행</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">개인정보 보유기간</td>
              <td className="border border-gray-300 px-4 py-2">서비스 제공 완료 후 5년</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">제공 항목</td>
              <td className="border border-gray-300 px-4 py-2">OrderId(주문번호), amount(금액), paymentKey(키값) 등</td>
            </tr>
          </tbody>
        </table>
        <p> - 개인정보의 이용기간은 위 개인정보는 위 수집, 활용 및 제3자 제공에 따른 이용목적을 위하여 정보가 제공된 날로부터 최대 5년까지 보유되며, 제공된 개인정보 이용을 거부하고자 할 경우 개인정보 관리책임자를 통해 열람, 정정, 삭제를 요구할 수 있습니다.</p>
        <p> - 개인정보 보유주체는 위 개인정보의 수집 및 이용, 제3자 제공 등을 거부할 수 있습니다. 다만, 동의 거부 시 서비스 이용이 제한될 수 있습니다. </p>
        <p> - 동의 철회 또는 서비스 탈퇴 시 지체없이 파기합니다 . </p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>4. 개인정보 파기절차 및 방법</b></span>
      <ol className="pl-5 space-y-2">
        <p>회사는 개인정보는 수집 및 이용목적이 달성된 후에는 보관기간 및 이용기간에 따라 해당 정보를 바로 파기하며, 절차 및 방법은 아래와 같습니다.</p>
        <p>① 전자적 파일 형태의 경우 복구 및 재생이 되지 않도록 기술적인 방법을 이용하여 안전하게 삭제하며, 그 밖에 기록물, 인쇄물, 서면 등의 경우 분쇄하거나 소각하여 파기합니다.</p>
        <p>② 다만, 내부 방침에 따라 아래 정보는 탈퇴일부터 최대 1년간 보관 후 파기합니다.</p>
        <p> - 안내메일 발송 및 CS문의 대응을 위해 서비스 가입 계정과 이메일 주소를 암호화하여 보관</p>
        <p> - 서비스 부정이용 기록</p>
        <p>③ 회사는 ‘개인정보 유효기간제’에 따라 1년간 서비스를 이용하지 않은 회원의 개인정보를 별도로 분리 보관 또는 삭제하고 있으며, 분리 보관된 개인정보는 4년간 보관 후 지체없이 파기합니다.</p>
        <p>④ 이 외에 법령에 따라 일정기간 보관해야 하는 개인정보는 해당 법령은 기재한 규정에 따라 보관하며(제 1조 3항) 다른 목적으로는 절대 이용하지 않습니다. 상세한 내용은 제 1조 3항을 따릅니다.</p>
      </ol>
    </section>

    <b>□ 정보주체와 법정대리인의 권리․의무 및 그 행사방법에 관한 사항</b>

    <section className="mb-8">
      <span><b>5. 이용자 및 법정대리인의 권리와 그 행사방법</b></span>
      <ol className="pl-5 space-y-2">
        <p>① 이용자는 언제든지 서비스내 ‘마이페이지’에서 자신의 개인정보를 조회하거나 수정할 수 있습니다.</p>
        <p>② 이용자는 언제든지 ‘회원탈퇴’ 등을 통해 개인정보의 수집 및 이용 동의를 철회할 수 있습니다.</p>
        <p>③ 이용자가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 해당 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.</p>
        <p>④ 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 관련 법과 정해진 규정에 따라 안전하게 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.</p>
        <p>⑤ 개인정보의 열람이 필요한 경우, 서비스내 ‘Contact us’에서 요청하거나 iopsspace@i-ops.co.kr’ 로 요청하실 수 있습니다.</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>6. 개인정보의 기술적/관리적 보호 대책</b></span>
      <ol className="pl-5 space-y-2">
        <p>회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.</p>
        <p>① 개인정보 암호화</p>
        <p>법령에서 암호화를 요구하고 있는 비밀번호, 고유식별정보, 계좌번호 외에 이메일 등을 추가로 암호화하여 보관하고 있습니다.</p>
        <p>② 대내외의 보안 위협으로부터 개인정보를 안전하게 관리</p>
        <p>회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.</p>
        <p>③ 개인정보처리시스템 접근 제한</p>
        <p>회사는 개인정보를 처리할 수 있도록 체계적으로 구성한 문서화 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소 등에 관한 기준을 수립하고 비밀번호의 생성 방법, 변경 주기 등을 규정 운영하며 기타 개인정보에 대한 접근통제를 위해 필요한 조치를 다하고 있습니다.</p>
        <p>④ 취급 직원의 최소화 및 교육</p>
        <p>회사는 이용자의 개인정보에 대한 접근권한을 최소로 제한하는 등의 관리적 대책을 시행하고 있습니다. 또한 개인정보취급자에 대한 정기 교육, 전사 임직원에 대한 수시 교육 및 캠페인을 통하여 회원 개인정보처리방침의 준수를 항상 강조하고 있습니다.</p>
        <p>⑤ 개인 이메일 아이디와 비밀번호 관리</p>
        <p>이용자가 사용하는 이메일 아이디와 비밀번호는 원칙적으로 이용자만이 사용하도록 되어 있습니다. 회사는 이용자의 개인적인 부주의로 이메일 아이디, 비밀번호 등 개인정보가 유출되어 발생한 문제와 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 비밀번호에 대한 보안 의식을 가지고 비밀번호를 자주 변경하며 공용 유무선 단말기에서의 로그인 시 개인정보가 유출되지 않도록 각별한 주의를 기울여 주시기 바랍니다.</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>7. 광고성 정보 전송</b></span>
      <ol className="pl-5 space-y-2">
        <p>① 회사는 이용자의 명시적인 수신거부의사에 반하여 영리목적의 광고성 정보를 전송하지 않습니다.</p>
        <p>② 신규 컨텐츠 알림이나 이벤트 정보안내 등 고객 지향적인 마케팅을 수행하기 위하여 광고성 정보를 이메일로 전송할 때 회사는 광고성 정보 전송에 대한 고객의 사전 동의를 얻고 본문란에 (광고)라는 문구를 본문 아래와 같이 고객이 광고성 정보임을 쉽게 알아볼 수 있도록 조치합니다.</p>
        <p>- 이메일 본문 란 : ‘(광고)’ 라는 문구를 본문 맨 처음에 빈칸 없이 한글/영문으로 표시합니다.</p>
        <p>③ 마케팅정보 수신에 동의한 이용자에게 이메일 전송 등으로 영리 목적의 광고성 정보를 전송할 때에도 전송자의 명칭을 표기하는 등 필요한 조치를 합니다.</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>8. 개인정보관리책임자 및 담당자의 연락처</b></span>
      <ol className="pl-5 space-y-2">
        <p>회사는 이용자의 개인정보 관련 문의사항 및 불만 처리 등을 위하여 아래와 같이 개인정보 보호책임자 및 담당자를 지정하고 있습니다.</p>
        <table className="border-collapse border border-gray-300 w-full">
          <thead>
            <tr>
              <th className="border border-gray-300 px-4 py-2">개인정보 보호책임자</th>
              <th className="border border-gray-300 px-4 py-2">개인정보 고충처리부서</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-4 py-2">
                <strong>이름:</strong> 김영욱<br/>
                <strong>소속:</strong> ㈜아이옵스<br/>
                <strong>직위:</strong> CEO<br/>
                <strong>전화:</strong> 042-322-7606<br/>
                <strong>메일:</strong> ywkim@i-ops.co.kr
              </td>
              <td className="border border-gray-300 px-4 py-2">
                <strong>이름:</strong> 정서윤<br/>
                <strong>소속:</strong> SD부<br/>
                <strong>직위:</strong> 선임 연구원<br/>
                <strong>전화:</strong> 042-322-7609<br/>
                <strong>메일:</strong> syjeong@i-ops.co.kr
              </td>
            </tr>
          </tbody>
        </table>
        <p>기타 개인정보 침해에 대한 신고나 상담이 필요한 경우에 아래 기관에 문의 가능합니다.</p>
        <p>- 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</p>
        <p>- 대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)</p>
        <p>- 경찰청 사이버안전국 (cyberbureau.police.go.kr / 국번없이 182)</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>9. 고지의 의무</b></span>
      <ol className="pl-5 space-y-2">
        <p>현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 서비스의 &apos;공지사항&apos;을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>부칙</b></span>
      <p>① 본 개인정보 처리방침은 2025년 1월 10일부터 적용됩니다.</p>
    </section>

    
  </div>
  );
};

export default PrivacyPopup;

